import React, { useEffect, useState } from "react";
import { Doughnut, Bar, Pie } from "react-chartjs-2";
import { Row, Col, Popover } from "antd";
import styled from "styled-components";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  PointElement,
  LineElement
} from "chart.js";
import { getDashboardDetails } from "../../Services/user";

// Register required chart elements
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, PointElement, LineElement);

// Styled components for Card and Wrapper
const CardWrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  height: auto;
  flex-direction: column;
  justify-content: space-between;
  .donut-div{
    height: 250px;
    width: 100%;
    display:grid;
    place-content:center;
  }
`;

const ChartTitle = styled.h3`
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
`;

const TestUserNote = styled.div`
  padding: 12px 20px 24px;
  font-size: 12.5px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  .view-link {
    border: none;
    background: none;
    color: #2563eb;
    text-decoration: underline;
    padding: 0;
    margin-left: 4px;
    font-size: 12.5px;
    cursor: pointer;
  }
  .view-link:hover {
    color: #1d4ed8;
  }
`;

const Star = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #6b7280;
  margin-left: 3px;
  vertical-align: super;
  line-height: 0;
`;

const TestUserList = styled.div`
  max-height: 220px;
  overflow-y: auto;
  min-width: 160px;
  > div {
    padding: 4px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 13px;
  }
  > div:last-child {
    border-bottom: none;
  }
`;

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getDashboardDetails();
        // console.log("res", res)
        setDashboardData(res);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchData();
  }, []);

  
  const genderData = {
    labels: ["Male", "Female", "Other", "Prefer not to say", "None"],
    datasets: [
      {
        data: dashboardData
          ? [
              dashboardData.total_male_users_count || 0,
              dashboardData.total_female_users_count || 0,
              dashboardData.total_other_users_count || 0,
              dashboardData.total_prefer_users_count || 0,
              dashboardData.gender_null_count || 0,
            ]
          : [0, 0, 0, 0, 0],
        backgroundColor: ["#36A2EB", "#FF6384", "#FFD93D", "#6BCB77", "#acacace5"],
      },
    ],
  };

 

  // Chart options to remove the grid
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
    // Doughnut specific options
    elements: {
      arc: {
        borderWidth: 2, // Adjust border width for doughnut
      },
    },
    // Adjust cutoutPercentage to change the hole size of the doughnut
    cutoutPercentage: 40, // Lower percentage will make the doughnut thicker
    scales: {
      // Remove grid from all axes
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
            display: false, // Hide the y-axis labels (ticks)
        },
      },
    },
  };

  const chartOptions1 = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
  
    // Adjust cutoutPercentage to change the hole size of the doughnut
    cutoutPercentage: 40, // Lower percentage will make the doughnut thicker
   
  };

  const InfoBoxWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 20px;

    .info-box {
      flex: 1 1 calc(33.333% - 20px);
      background: #fff;
      border-width: 1px;
      border-radius: 12px;
      padding: 20px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      position: relative;
      transition: transform 0.2s ease;

      &:hover {
        transform: translateY(-3px);
      }

      .title {
        font-size: 14px;
        font-weight: 500;
        color: #555;
      }

      .value {
        font-size: 28px;
        font-weight: 700;
        color: #000;
        margin: 5px 0;
      }

      .note {
        font-size: 13px;
        color: #3ccf91;
      }

      .note.inactive {
        color: #1890ff;
      }

      .icon {
        position: absolute;
        top: 18px;
        right: 20px;
        font-size: 18px;
        opacity: 0.4;
      }

      &.total {
        border-left: 4px solid #3f87f5;
      }

      &.paid {
        border-left: 4px solid rgb(34 197 94 / var(--tw-border-opacity, 1));
      }

      &.free {
        border-left: 4px solid rgb(249 115 22 / var(--tw-border-opacity, 1));
      }

      &.earning {
        border-left: 4px solid rgb(16 185 129 / var(--tw-border-opacity, 1));
      }

      &.input {
        border-left: 4px solid rgb(168 85 247 / var(--tw-border-opacity, 1));
      }

      &.output {
        border-left: 4px solid rgb(236 72 153 / var(--tw-border-opacity, 1));
      }

      &.coupon-assigned {
        border-left: 4px solid rgb(234 179 8 / var(--tw-border-opacity, 1));
      }

      &.coupon-redeemed {
        border-left: 4px solid rgb(20 184 166 / var(--tw-border-opacity, 1));
      }

      /* two figures side by side in one card (input | output tokens) */
      &.split {
        flex-direction: row;
        flex: 1 1 calc(50% - 20px);
        padding: 0;
      }
      .part {
        flex: 1;
        padding: 20px;
      }
      .part.divided {
        border-left: 1px solid #eee;
      }

      /* Paid Users breakdown: its own full-width card */
      &.paid-breakdown {
        flex: 1 1 100%;
        border-left: 4px solid rgb(34 197 94 / var(--tw-border-opacity, 1));
      }
      .pb-sub {
        font-size: 12px;
        color: #888;
        margin-top: 2px;
      }
      .pb-cols {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px 32px;
        margin-top: 16px;
      }
      @media (max-width: 900px) {
        .pb-cols { grid-template-columns: 1fr; }
      }
      .pb-head {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #888;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
        margin-bottom: 8px;
      }
      .pb-row {
        padding: 6px 0;
      }
      .pb-line {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
      }
      .pb-count {
        font-weight: 700;
        font-variant-numeric: tabular-nums;
      }
      .pb-bar {
        height: 6px;
        border-radius: 3px;
        background: #f1f5f9;
        margin-top: 5px;
        overflow: hidden;
      }
      .pb-bar > span {
        display: block;
        height: 100%;
        border-radius: 3px;
        background: rgb(34 197 94);
      }
      .pb-empty {
        font-size: 13px;
        color: #aaa;
      }
    }
  `;



  const getTotalInputTokens = (data) => {
    if (!data) return 0;
    return data.reduce((sum, item) => sum + (item.total_input_token || 0), 0);
  };

  const getTotalOutputTokens = (data) => {
    if (!data) return 0;
    return data.reduce((sum, item) => sum + (item.total_output_token || 0), 0);
  };

  const categoryTokenData = {
    labels: dashboardData?.token_usage_by_category.map(item => item.category_name) ?? [],
    datasets: [
      {
        label: "Input Tokens",
        data: dashboardData?.token_usage_by_category.map(item => item.total_input_token) ?? [],
        backgroundColor: "#36A2EB",
      },
      {
        label: "Output Tokens",
        data: dashboardData?.token_usage_by_category.map(item => item.total_output_token) ?? [],
        backgroundColor: "#FF6384",
      },
    ],
  };

  const planUsageList = dashboardData?.plan_usage_list || [];
  const totalPlanUsers = planUsageList.reduce((sum, plan) => sum + plan.user_count, 0);

  // Convert to percentage
  const planPercentageData = {
    labels: planUsageList.map(plan => plan.name),
    datasets: [
      {
        data: planUsageList.map(plan =>
          totalPlanUsers > 0 ? ((plan.user_count / totalPlanUsers) * 100).toFixed(2) : 0
        ),
        backgroundColor: [
          "#4B9CD3", // Blue
          "#FF6B6B", // Red
          "#FFD93D", // Yellow
          "#6BCB77", // Green
          "#845EC2", // Purple
          "#FF9671", // Orange
          "#00C9A7", // Teal
        ],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  };

  const percenChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const percent = context.raw || 0;
            // const total = context.dataset.data.reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
            const index = context.dataIndex;
            const userCount = planUsageList[index]?.user_count || 0;

            return `${label}: ${userCount} users (${percent}%)`;
          },
        },
      },
    },
  };

  const excludedTestUsers = dashboardData?.excluded_test_users ?? [];


  return (
    <>
      <InfoBoxWrapper>
        <div className="info-box total">
          <div className="title">Total Users</div>
          <div className="value">{dashboardData?.total_number_of_users_count ?? 0}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users h-5 w-5 text-blue-500" data-lov-id="src/pages/Dashboard.tsx:56:14" data-lov-name="Users" data-component-path="src/pages/Dashboard.tsx" data-component-line="56" data-component-file="Dashboard.tsx" data-component-name="Users" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-blue-500%22%7D"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></div>
        </div>

        <div className="info-box paid">
          <div className="title">Paid Users (Active)<Star>*</Star></div>
          <div className="value">{dashboardData?.total_paid_users_count ?? 0}</div>
          <div className="pb-sub">Previous: {dashboardData?.previous_paid_users_count ?? 0} &middot; Total: {dashboardData?.all_paid_users_count ?? 0}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-credit-card h-5 w-5 text-green-500" data-lov-id="src/pages/Dashboard.tsx:68:14" data-lov-name="CreditCard" data-component-path="src/pages/Dashboard.tsx" data-component-line="68" data-component-file="Dashboard.tsx" data-component-name="CreditCard" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-green-500%22%7D"><rect width="20" height="14" x="2" y="5" rx="2"></rect><line x1="2" x2="22" y1="10" y2="10"></line></svg></div>
        </div>

        <div className="info-box free">
          <div className="title">Free Users</div>
          <div className="value">{dashboardData?.current_free_users_count ?? 0}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-x h-5 w-5 text-orange-500" data-lov-id="src/pages/Dashboard.tsx:80:14" data-lov-name="UserX" data-component-path="src/pages/Dashboard.tsx" data-component-line="80" data-component-file="Dashboard.tsx" data-component-name="UserX" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-orange-500%22%7D"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><line x1="17" x2="22" y1="8" y2="13"></line><line x1="22" x2="17" y1="8" y2="13"></line></svg></div>
        </div>

        <div className="info-box earning">
          <div className="title">Total Earnings </div>
          <div className="value">${(dashboardData?.total_earning_amount ?? 0).toFixed(2)}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign h-5 w-5 text-emerald-500" data-lov-id="src/pages/Dashboard.tsx:120:14" data-lov-name="DollarSign" data-component-path="src/pages/Dashboard.tsx" data-component-line="120" data-component-file="Dashboard.tsx" data-component-name="DollarSign" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-emerald-500%22%7D"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></div>
        </div>

        <div className="info-box coupon-assigned">
          <div className="title">Coupon Assigned<Star>*</Star></div>
          <div className="value">{dashboardData?.total_coupon_assigned_count ?? 0}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12v10H4V12"></path><path d="M2 7h20v5H2z"></path><path d="M12 22V7"></path><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg></div>
        </div>

        <div className="info-box coupon-redeemed">
          <div className="title">Coupon Redeemed (Active)<Star>*</Star></div>
          <div className="value">{dashboardData?.total_coupon_redeemed_count ?? 0}</div>
          <div className="pb-sub">Previous: {dashboardData?.previous_coupon_used_count ?? 0} &middot; Total: {dashboardData?.all_coupon_used_count ?? 0}</div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12l2 2 4-4"></path><circle cx="12" cy="12" r="10"></circle></svg></div>
        </div>

        <div className="info-box input split">
          <div className="part">
            <div className="title">Total Input Tokens</div>
            <div className="value">{getTotalInputTokens(dashboardData?.token_usage_by_category)}</div>
          </div>
          <div className="part divided">
            <div className="title">Total Output Tokens</div>
            <div className="value">{getTotalOutputTokens(dashboardData?.token_usage_by_category)}</div>
          </div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap h-5 w-5 text-blue-500" data-lov-id="src/pages/Dashboard.tsx:134:14" data-lov-name="Zap" data-component-path="src/pages/Dashboard.tsx" data-component-line="134" data-component-file="Dashboard.tsx" data-component-name="Zap" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-blue-500%22%7D"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg></div>
        </div>

        <div className="info-box output split">
          <div className="part">
            <div className="title">Paid Input Tokens<Star>*</Star></div>
            <div className="value">{dashboardData?.paid_input_tokens ?? 0}</div>
          </div>
          <div className="part divided">
            <div className="title">Paid Output Tokens<Star>*</Star></div>
            <div className="value">{dashboardData?.paid_output_tokens ?? 0}</div>
          </div>
          <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-zap h-5 w-5 text-blue-500" data-lov-id="src/pages/Dashboard.tsx:134:14" data-lov-name="Zap" data-component-path="src/pages/Dashboard.tsx" data-component-line="134" data-component-file="Dashboard.tsx" data-component-name="Zap" data-component-content="%7B%22className%22%3A%22h-5%20w-5%20text-blue-500%22%7D"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path></svg></div>
        </div>

        <div className="info-box paid-breakdown">
          <div className="title">Paid Users Breakdown<Star>*</Star></div>
          <div className="pb-sub">
            {dashboardData?.total_paid_users_count ?? 0} active paid users, including cancelled plans still active till expiry and team accounts
          </div>
          <div className="pb-cols">
            {[["By Plan", "by_plan"], ["By Renewal", "by_renewal"], ["By Source", "by_source"]].map(([heading, key]) => {
              const items = dashboardData?.paid_users_breakdown?.[key] || [];
              const total = dashboardData?.total_paid_users_count || 0;
              return (
                <div key={key}>
                  <div className="pb-head">{heading}</div>
                  {items.length ? items.map((item) => (
                    <div className="pb-row" key={item.label}>
                      <div className="pb-line">
                        <span>{item.label}</span>
                        <span className="pb-count">{item.count}</span>
                      </div>
                      <div className="pb-bar">
                        <span style={{ width: `${total ? Math.min(100, (item.count / total) * 100) : 0}%` }} />
                      </div>
                    </div>
                  )) : <div className="pb-empty">No data</div>}
                </div>
              );
            })}
          </div>
        </div>

      </InfoBoxWrapper>


    
      <Row gutter={[16, 16]} style={{ padding: "20px" }}>
        <Col xs={24} sm={12}>
          <CardWrapper>
            <ChartTitle>Gender-based User Count</ChartTitle>
            <div className="donut-div">
              <Doughnut data={genderData} options={chartOptions1} />
            </div>
          </CardWrapper>
        </Col>
        

        <Col xs={24} sm={12}>
          <CardWrapper>
            <ChartTitle>Plan Users Distribution (%)</ChartTitle>
            <div className="donut-div">
              <Pie data={planPercentageData} options={percenChartOptions} />
            </div>
          </CardWrapper>
        </Col>

        <Col xs={24} sm={24}>
          <CardWrapper>
            <ChartTitle>Token Usage by Category (Input vs Output)</ChartTitle>
                <Bar data={categoryTokenData} options={chartOptions}  width={2200} height={600}/>
          </CardWrapper>
        </Col>

      </Row>

      <TestUserNote>
        <Star>*</Star> Test users are excluded from the Paid Users, Paid Input/Output Tokens, Paid Users Breakdown, Coupon Assigned and Coupon Redeemed cards above.
        {excludedTestUsers.length > 0 && (
          <Popover
            trigger="click"
            title={`Excluded test users (${excludedTestUsers.length})`}
            content={
              <TestUserList>
                {excludedTestUsers.map((u) => (
                  <div key={u.id}>{u.name ? `${u.name} (#${u.id})` : `User #${u.id}`}</div>
                ))}
              </TestUserList>
            }
          >
            <button type="button" className="view-link">View {excludedTestUsers.length}</button>
          </Popover>
        )}
      </TestUserNote>
    </>
  );
};

export default Dashboard;
